<template>
    <div class="dm-buttons-group d-flex align-items-center gap-8-px">
        <template v-for="btn in buttons" :key="btn.mode">
            <button v-if="btn.show.includes(dmMessageMode)" class="nav-btn" @click="showScreen(btn.mode)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path :d="btn.icon"></path>
                </svg>
            </button>
        </template>
    </div>
</template>

<script>
/**
 * ****************************************************************************
 * @description     :   DM Message Navigation Buttons Component
 * @created at      :   2025/11/25
 * @created by      :   DaoNX
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import { mapState, mapMutations } from 'vuex';

const DM_TITLE = {
    receive: 'DM受信一覧',
    send: 'DM送信一覧',
    compose: '新規DM作成',
    group: 'グループ設定',
    groupDetail: 'グループ設定（新規登録）'
};

export default {
    name: 'DMMessageButtons',
    computed: {
        ...mapState('app', ['dmMessageMode']),
        buttons() {
            return [
                {
                    mode: 'group',
                    show: ['receive', 'send', 'compose'],
                    icon: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z'
                },
                {
                    mode: 'receive',
                    show: ['send', 'compose', 'group'],
                    icon: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'
                },
                {
                    mode: 'send',
                    show: ['receive', 'compose', 'group'],
                    icon: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z'
                },
                {
                    mode: 'compose',
                    show: ['receive', 'send'],
                    icon: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'
                },
                {
                    mode: 'groupDetail',
                    show: ['groupDetail'],
                    icon: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'
                }
            ];
        }
    },
    methods: {
        ...mapMutations('app', ['setDmMessageMode', 'updatePopupConfig']),
        showScreen(type) {
            this.updatePopupConfig({ title: DM_TITLE[type] || 'DM受信一覧' });
            this.setDmMessageMode(type);
            if (type == 'group') {
                this.updatePopupConfig({
                    dimensions: {
                        width: '50%',
                        height: '80%'
                    }
                });
            } else {
                this.updatePopupConfig({
                    dimensions: {
                        width: '40%',
                        height: '80%'
                    }
                });
            }
            if (type == 'groupDetail') {
                this.showScreen('group');
            }
        }
    }
};
</script>

<style scoped>
.dm-buttons-group {
    display: flex;
    align-items: center;
}

.nav-btn {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    cursor: pointer;
    padding: 6px;
    width: 29px;
    height: 29px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: background 0.2s;
}

.nav-btn:hover {
    background: rgba(255, 255, 255, 0.3);
}
</style>
